<template>
  <div>
    <div v-if="pageState.mode == 'main'">
      <Promised :promise="loadData">
        <template v-slot:pending>
          <div class="align-items-center justify-content-center loading-card" style="height: 100%; width: 100%">
            <card-state-icon icon-class="fa-4x fas fa-spinner fa-spin text-secondary" message="Loading..." />
          </div>
        </template>
        <template v-slot="data">
          <span class="d-none">{{ data }}</span>
          <form-wizard @on-complete="postBatch" title="New Transportation Inspection Batch" subtitle="" color="#930f2e">
            <tab-content title="Select District" :before-change="loadBuses">
              <b-form class="mb-4">
                <b-form-row>
                  <div class="col-md-12">
                    <b-form-row class="mb-3">
                      <label class="col-md-2 col-form-label">Districts:</label>
                      <b-form-select v-model="selectedArea" text-field="name" value-field="areaId" class="col-md-3" :options="areaOptions" />
                    </b-form-row>
                    <b-form-row>
                      <label class="col-md-2 col-form-label">District LEA:</label>
                      <my-districts :districts="districtOptions" v-model="district" default-sort="name" />
                    </b-form-row>
                    <b-form-row>
                      <label class="col-md-2 col-form-label">Description:</label>
                      <b-form-input v-model="description" class="col-md-8" placeholder="Enter a description of the batch, or leave blank to use a default description." />
                    </b-form-row>
                  </div>
                </b-form-row>
              </b-form>
            </tab-content>
            <tab-content title="Select Buses">
              <bus-list :allow-item-check="true" :show-action-column="true" :items="buses" @item-checked="onItemChecked" :is-new-inspection="true" />
            </tab-content>
            <tab-content title="Review">
              <b-form class="mb-4">
                <div class="col-md-8">
                  <b-form-row>
                    <label class="col-md-2 col-form-label">District LEA:</label>
                    <b-form-input v-model="district" class="col-md-4" plaintext />
                  </b-form-row>
                  <b-form-row>
                    <label class="col-md-2 col-form-label">District Name:</label>
                    <b-form-input class="col-md-8" plaintext id="input-id" :value="districtName" />
                  </b-form-row>
                  <b-form-row>
                    <label class="col-md-2 col-form-label">Description:</label>
                    <b-form-input v-model="description" class="col-md-8" id="input-id" :placeholder="description || defaultDescription" />
                  </b-form-row>
                </div>
              </b-form>
              <paginated-table small :fields="tableFields" :items="BatchMaintenance.SelectedBuses" />
            </tab-content>
            <template slot="next" slot-scope="props">
              <div>
                <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle" :disabled="!isDistrictSelected">
                  Next
                </wizard-button>
              </div>
            </template>
          </form-wizard>
        </template>
        <template v-slot:rejected="error" class="align-items-center justify-content-center">
          <card-state-icon icon-class="fa-4x fas fa-exclamation-triangle text-danger" :message="'Error: ' + error.message" />
        </template>
      </Promised>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex'
import { Promised } from 'vue-promised'
import CardStateIcon from '../../../CardStateIcon'
import PaginatedTable from '../../../PaginatedTable'
import BusList from '../../common/BusList'
import { FormWizard, TabContent, WizardButton } from 'vue-form-wizard'
import MyDistricts from '../../common/MyDistricts'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { DPSAFT } from '../../../../stores/dpsaft/index'
const dpsaftStore = new DPSAFT()

export default {
  name: 'create-batch',
  data() {
    return {
      description: null,
      loadData: null,
      tableFields: [
        { key: 'id', sortable: true },
        { key: 'stickerNumber', sortable: true },
        { key: 'vinNumber', sortable: true },
        { key: 'permitNumber', sortable: true }
        // {
        //   key: 'action',
        //   sortable: false,
        //   thClass: 'text-right',
        //   class: 'text-right'
        // }
      ],
      pageState: {
        mode: 'main',
        itemSelections: []
      }
    }
  },
  computed: {
    ...mapState('globalModule', ['userContext', 'leaContext']),
    ...mapGetters('globalModule', ['districts']),
    ...mapState('DPSAFT', ['filter', 'assignedDistricts', 'buses', 'areas',  'assignedAreas', 'selectedAreaId']),
    ...mapState('DPSAFT/Trans', ['BatchMaintenance']),
    district: {
      set(district) {
        this.$store.commit('DPSAFT/setFilterDistrict', district)
      },
      get() {
        return this.filter.district
      }
    },
    selectedArea: {
      set(area) {
        this.$store.commit('DPSAFT/setSelectedAreaId', area)
      },
      get() {
        return this.selectedAreaId
      }
    },
    areaOptions() { return [{areaId: -1, name: 'My Districts'}, {areaId: 0, name: 'All Districts'}] },
    districtOptions() { return this.selectedArea == -1 ? this.assignedDistricts : this.districts().map(d => ({ leaNumber: d.number, name: d.name })) },
    districtName() {
      if (this.district) {
        return this.leaContext.LeaDictionary[this.district].name
      }
      return 'Not Selected'
    },
    defaultDescription(){
      if(this.district){
        if(this.BatchMaintenance.SelectedBuses.length > 0){
          return `${this.districtName}: ${this.BatchMaintenance.SelectedBuses.length} Bus Inspections`
        }

        return `${this.district.name} Bus Inspection`  
      }
      return "Bus Inspection"
    },
    isDistrictSelected() {
      return (this.district || '').length > 0
    }
  },
  mounted() {
    this.loadData = this.$store.dispatch(`${dpsaftStore.path}/${dpsaftStore.actions.getAssignedDistricts.name}`)
    this.selectedArea = -1
  },
  methods: {
    postBatch() {
      return this.$store
        .dispatch('DPSAFT/Trans/initializeBatch', {
          description: this.description || this.defaultDescription,
          district: this.district,
          schoolLea: null
        })
        .then(() => this.$router.push({ path: '/transportation/batches' }))
    },
    loadBuses() {
      return this.$store
        .dispatch('DPSAFT/getBuses', {
          areaId: null,
          districtLea: this.district,
          coopLea: null,
          includeLatestInspection: true
        })
        .then(() => true)
    },
    onItemChecked(checkedItems) {
      this.BatchMaintenance.SelectedBuses = checkedItems
    },
  },
  components: {
    PaginatedTable,
    BusList,
    FormWizard,
    TabContent,
    MyDistricts,
    Promised,
    CardStateIcon,
    WizardButton,
  }
}
</script>
